import { useContext } from 'react';

import { useAuth } from '../auth/AuthenticationContext.jsx';
import { FlagContext } from './FlagContext.jsx';

// Port of the app's FlagSet (components/common/FlagSet.js): the "Enable
// development features" block in the Menu, one tick box per toggleable flag the
// account is eligible for. It renders nothing for an ordinary account — the block
// exists only for accounts in the pilot / debug Cognito groups — so most people
// never see it.
//
// Native checkboxes stand in for the app's radio-styled control: the browser's own
// control is keyboard- and screen-reader-complete for free, and the label wraps
// the input so the whole row is the target. The state shown is the stored
// preference filtered by eligibility (activeUserFlags), which for the flags listed
// here is the same thing — every listed flag is eligible by construction.
const labels = {
  pilot: 'Pilot features',
  debug: 'Debug features',
};

export default function FlagSet() {
  const { eligableGroups = [] } = useAuth();
  const { activeUserFlags, handleFlagToggle, toggleableFlags } =
    useContext(FlagContext);

  // Listed in the app's toggle order (pilot, then debug) rather than whatever
  // order the token happens to carry the groups in.
  const flags = toggleableFlags.filter((flag) => eligableGroups.includes(flag));
  if (flags.length === 0) {
    return null;
  }

  return (
    <section className="flag-set" aria-labelledby="flag-set-title">
      <h3 id="flag-set-title" className="flag-set__title">
        Enable development features
      </h3>
      {flags.map((flag) => (
        <label key={flag} className="flag-set__row">
          <input
            type="checkbox"
            checked={activeUserFlags.includes(flag)}
            onChange={() => handleFlagToggle(flag)}
          />
          {labels[flag]}
        </label>
      ))}
    </section>
  );
}
